import * as actions from '@/AppRedux/actions/paymentGateway/paymentBeamType'
import { PaymentMethod } from '@/AppRedux/actions/paymentGateway/paymentBeamType'
// ประกาศประเภทของโครงสร้างข้อมูล state
export type PaymentMethodTypes = Record<PaymentMethod, boolean>;

export interface PaymentLinkState {
  paymentMethodTypes: PaymentMethodTypes;
  amount: number;
  currency: string;
  referenceId: string;
  description: string;
  collectDeliveryAddress: boolean;
  redirectUrl: string;
  loading: boolean;
  createdLink?: {
    id: string;
    url: string;
  };
  error?: string;
}

// กำหนดค่าเริ่มต้นของ state สำหรับการสร้าง Payment Link
const initialState: PaymentLinkState = {
  paymentMethodTypes: {
    card: true,
    cardInstallments: false,
    eWallets: true,
    mobileBanking: true,
    qrPromptPay: true,
    buyNowPayLater: false
  },
  amount: 0,
  currency: 'THB',            // ตั้ง THB เป็นค่า default (ปรับเปลี่ยนได้ตามต้องการ)
  referenceId: '',
  description: '',
  collectDeliveryAddress: false,
  redirectUrl: '',            // ใส่ URL เว็บไซต์เราที่ต้องการ redirect หลังชำระ (ถ้ามี)
  loading: false,
  createdLink: undefined,
  error: undefined
};

const paymentLinkReducer = (
  state: PaymentLinkState = initialState, 
  action: actions.PaymentLinkAction
): PaymentLinkState => {
  switch(action.type) {
    case actions.SET_PAYMENT_METHOD_ENABLED: {
      const { method, enabled } = action.payload;
      return {
        ...state,
        paymentMethodTypes: {
          ...state.paymentMethodTypes,
          [method]: enabled
        }
      };
    }
    case actions.SET_AMOUNT:
      return {
        ...state,
        amount: action.payload
      };
    case actions.SET_CURRENCY:
      return {
        ...state,
        currency: action.payload
      };
    case actions.SET_REFERENCE_ID:
      return {
        ...state,
        referenceId: action.payload
      };
    case actions.SET_DESCRIPTION:
      return {
        ...state,
        description: action.payload
      };
    case actions.CREATE_PAYMENT_LINK_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined  // เริ่มเรียก API เคลียร์ error เก่าทิ้ง
      };
    case actions.CREATE_PAYMENT_LINK_SUCCESS:
      console.log("reducer payment link success ", action.payload);
      return {
        ...state,
        loading: false,
        // บันทึกข้อมูล payment link ที่สร้างได้ (id, url, status)
        createdLink: {
          id: action.payload.id,
          url: action.payload.url
        },
        error: undefined
      };
    case actions.CREATE_PAYMENT_LINK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    case actions.PAYMENT_RESET:
      return {
        ...initialState,
        error: undefined
      }
    default:
      return state;
  }
};

export default paymentLinkReducer;